import { render, staticRenderFns } from "./TelephoneRow.vue?vue&type=template&id=67cdcb26&"
import script from "./TelephoneRow.vue?vue&type=script&lang=ts&"
export * from "./TelephoneRow.vue?vue&type=script&lang=ts&"
import style0 from "./TelephoneRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cdcb26')) {
      api.createRecord('67cdcb26', component.options)
    } else {
      api.reload('67cdcb26', component.options)
    }
    module.hot.accept("./TelephoneRow.vue?vue&type=template&id=67cdcb26&", function () {
      api.rerender('67cdcb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/TelephoneRow.vue"
export default component.exports